type AudioMetricsProps = {
  milestoneName: string;
  monitoringEngagementId: string;
  cameraUuid: string;
  clientLivestreamId: string;
  streamType: string;
  cameraModel: string;
  cameraFwVersion: string;
  eventTimestamp?: string;
  videoResolution: string;
  cameraWifiRssi: string;
  locationId: number;
  userId: string;
  cameraSettings: Record<string, unknown>;
  monitoringSpecialistId: string;
  sourceApplication: string;
  reasonDescription?: string;
};

export const useAudioMetrics = () => {
  const sendMetric = ({
    milestoneName,
    monitoringEngagementId,
    cameraUuid,
    clientLivestreamId,
    streamType,
    cameraModel,
    cameraFwVersion,
    eventTimestamp = new Date().toISOString(),
    videoResolution,
    cameraWifiRssi,
    locationId,
    userId,
    cameraSettings,
    monitoringSpecialistId,
    sourceApplication,
    reasonDescription,
  }: AudioMetricsProps) => {
    return fetch(
      `${process.env.REACT_APP_MONITORING_METRICS_URL}/v1/metrics/livestream`,
      {
        method: 'POST',
        body: JSON.stringify([
          {
            milestoneName,
            monitoringEngagementId,
            cameraUuid,
            clientLivestreamId,
            streamType,
            cameraModel,
            cameraFwVersion,
            eventTimestamp,
            videoResolution,
            cameraWifiRssi,
            locationId,
            userId,
            cameraSettings,
            monitoringSpecialistId,
            sourceApplication,
            reasonDescription,
          },
        ]),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        keepalive: true,
      }
    );
  };

  return {
    sendMetric,
  };
};
